import * as React from 'react';
import { Link } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, ImageWithCaption } from '@emorg-prd/standard-react';
import { Grid, Button, Alert } from '../../common';
import NewConnectedPORInfoImage from '../../../images/newConnectedPORInfoImage.png';
import './NewConnectedPORInfoModal.css';


interface NewConnectedPORInfoModalProps {
	visible: boolean;
	onClose: () => any;
}

interface NewConnectedPORInfoModalState {
}

export default class NewConnectedPORInfoModal extends React.Component<
	NewConnectedPORInfoModalProps,
	NewConnectedPORInfoModalState> {


	componentDidMount() {
		const overlay = document.querySelector('.por-info-modal .em-c-modal__overlay');
		if (overlay) {
			const handler = (e: Event) => {
				e.stopPropagation(); // blocks closing by overlay
			};
			overlay.addEventListener('click', handler, true);
			// refs for cleanup
			(this as any)._overlay = overlay;
			(this as any)._overlayHandler = handler;
		}
	}

	componentWillUnmount() {
		const overlay = (this as any)._overlay as HTMLElement | undefined;
		const handler = (this as any)._overlayHandler as ((e: Event) => void) | undefined;
		overlay?.removeEventListener('click', handler!, true);
	}

	render() {
		return (<>
			<button
				type="button"
				className="em-js-modal-trigger"
				style={{ display: 'none' }}
				aria-hidden="true"
			>
				<span className="em-c-primary-nav__link" />
			</button>
			<Modal
				show={this.props.visible}
				optionalClass='por-info-modal'
			>
				<ModalHeader
					onClick={this.props.onClose}
					title="New Connected Port Opening Request"
				/>
				<ModalBody>
					<Alert
						variant="warning"
						className="no-alert-actions"
						body='For connected Port Opening Requests please go to
								the subscriptions page and follow the instructions
								in the image below.'
						onClose={() => []}
					/>
					<ImageWithCaption
						src={NewConnectedPORInfoImage}
						caption=""
						alt="NewConnectedPORInfoImage"
					/>
				</ModalBody>
				<ModalFooter>
					<Grid variant="2up">
						<Grid.Item>
							<Button
								variant="secondary"
								onClick={this.props.onClose}>
								Cancel
							</Button>
						</Grid.Item>
						<Grid.Item>
							<Link to="/subscriptions" className="redirect-button">
								<Button
									variant="primary"
									optionalClass="redirect-button"
								>
									Go to Subscriptions
								</Button>
							</Link>
						</Grid.Item>
					</Grid>
				</ModalFooter>
			</Modal>
		</>
		);
	}
}
